import React, { useState } from 'react'

import SubscribeSimplifiedAccesResultsModal from './subscribe-simplified-acces-results-modal/SubscribeSimplifiedAccesResultsModal'
import SubscribeSimplifiedNotProfessionalEmailModal from './subscribe-simplified-not-professional-email-modal/SubscribeSimplifiedNotProfessionalEmailModal'
import { SubscribeSimplifiedModalTypeEnum } from './utils/subscribe-simplified-modal-type.enum'
import { SubcribeSimplifiedModalProps } from '../login.types'

const SubscribeSimplifiedModal = ({
  onSubscribe: onAccessResults,
  isLoading,
  helperText,
  setModalType,
}: SubcribeSimplifiedModalProps) => {
  const [modalSubscribeSimplifiedType, setModalSubscribeSimplifiedType] =
    useState<SubscribeSimplifiedModalTypeEnum>(
      SubscribeSimplifiedModalTypeEnum.ACCESS_RESULTS,
    )

  switch (modalSubscribeSimplifiedType) {
    case SubscribeSimplifiedModalTypeEnum.ACCESS_RESULTS:
      return (
        <SubscribeSimplifiedAccesResultsModal
          onAccessResults={onAccessResults}
          isLoading={isLoading}
          setModalSubscribeSimplifiedType={setModalSubscribeSimplifiedType}
          helperText={helperText}
        />
      )
    case SubscribeSimplifiedModalTypeEnum.NOT_PROFESSIONAL_EMAIL:
      return (
        <SubscribeSimplifiedNotProfessionalEmailModal
          setModalSubscribeSimplifiedType={setModalSubscribeSimplifiedType}
          setModalType={setModalType}
        />
      )
    default:
      return null
  }
}

export default SubscribeSimplifiedModal
